import React, { useEffect, useRef, useState } from "react";
import Logo from "../assets/logo.svg";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Button from "./common/Button";
import { ChevronDown, Menu, X } from "lucide-react";

const Navbar = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const isCourseDetails = /^\/courses\/[^/]+$/.test(location.pathname);

  const [openDropdown, setOpenDropdown] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const dropdownRef = useRef(null);

  const isActive = (path) => location.pathname === path;

  const getNavLinkClassName = (path, mobile = false) => {
    const active = isActive(path);

    if (mobile) {
      return active
        ? "block rounded-lg bg-[#FFF0EB] px-3 py-2 font-semibold text-[#FF6636]"
        : "block px-3 py-2 font-semibold text-black";
    }

    return active
      ? "p-2 font-semibold whitespace-nowrap text-white bg-[#FF6636] rounded-full"
      : "p-2 font-semibold whitespace-nowrap text-black";
  };

  const renderNavLinks = (mobile = false) => (
    <>
      <Link to="/courses" className={getNavLinkClassName("/courses", mobile)}>
        Courses
      </Link>

      <Link
        to="/productandservices"
        className={getNavLinkClassName("/productandservices", mobile)}
      >
        Products & Services
      </Link>

      <Link to="/about-us" className={getNavLinkClassName("/about-us", mobile)}>
        About Us
      </Link>

      <Link
        to="/contact-us"
        className={getNavLinkClassName("/contact-us", mobile)}
      >
        Contact Us
      </Link>
    </>
  );

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpenDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className={`px-6 ${isCourseDetails ? "bg-[#F5F5F5]" : "bg-white"}`}>
      <div className="mx-auto w-full max-w-[1719px]  py-3  ">
        <div className="flex items-center justify-between gap-8">
          <div className="flex min-w-0 items-center  gap-16  2xl:gap-[91px]">
            <Link to="/" className="shrink-0">
              <img
                src={Logo}
                alt="website nav bar logo"
                className="w-9 sm:w-auto"
              />
            </Link>

            {/* Desktop Nav */}
            <div className="hidden min-w-0 flex-1 items-center gap-4 xl:flex xl:gap-8 min-[1660px]:gap-20 text-sm xl:text-base">
              {renderNavLinks()}
            </div>
          </div>

          {/* Right */}
          <div className="flex shrink-0 items-center gap-3 min-[1920px]:gap-4">
            {/* Desktop Buttons */}
            <div className="hidden gap-3 sm:flex">
              <Button
                btnClassName="rounded-full bg-[#FF6636] text-white font-semibold h-9 2xl:h-11 w-24 2xl:w-[129px]"
                btnText="Log In"
                onClick={() => navigate("/login")}
              />

              <Button
                btnClassName="bg-[#923D8C] rounded-full text-white font-semibold h-9 2xl:h-11 w-24 2xl:w-[129px]"
                btnText="Sign Up"
                onClick={() => navigate("/signup")}
              />
            </div>

            {/* Mobile Menu Button */}
            <button
              className="xl:hidden"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              aria-label="Toggle menu"
            >
              {mobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="flex flex-col gap-4 border-t pt-4 pb-4 mt-5 xl:hidden">
            {renderNavLinks(true)}

            <div className="flex gap-3 pt-2">
              <Button
                btnClassName="rounded-full bg-[#FF6636] text-white font-semibold h-9 w-24"
                btnText="Log In"
                onClick={() => navigate("/login")}
              />

              <Button
                btnClassName="bg-[#923D8C] rounded-full text-white font-semibold h-9 w-24"
                btnText="Sign Up"
                onClick={() => navigate("/signup")}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Navbar;

export const AuthNavBar = () => {
  const dropdownRef = useRef(null);
  const [openDropdown, setOpenDropdown] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpenDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const navLinks = (
    <>
      <div
        className="relative"
        ref={dropdownRef}
        onClick={() => navigate('/courses')}
      >
        <div className="flex items-center px-2.5 gap-2 cursor-pointer font-semibold whitespace-nowrap">
          <span>Courses</span>

          {/* <ChevronDown
            size={16}
            className={`transition-transform duration-200 ${
              openDropdown ? "rotate-180" : ""
            }`}
          /> */}
        </div>
        {/* {openDropdown && (
          <div className="absolute flex flex-col px-3 py-2 z-10 left-0 mt-2 shadow-md w-[170px] bg-[#F5F5F5] space-y-3">
            <Link>Science</Link>

            <Link>Technology</Link>
            <Link>Engineering</Link>
            <Link>Arts</Link>
            <Link>Mathematics</Link>
          </div>
        )} */}
      </div>

      {/* <Link
        to="/"
        className="px-2.5 font-semibold text-black whitespace-nowrap"
      >
        Camp/ Competitions
      </Link> */}

      <Link
        to="/productandservices"
        className="px-2.5 font-semibold text-black whitespace-nowrap"
      >
        Products & Services
      </Link>

      <Link to="/about-us" className="px-2.5 font-semibold text-black whitespace-nowrap">
        About Us
      </Link>

      <Link to="/contact-us" className="px-2.5 font-semibold text-black whitespace-nowrap">
        Contact Us
      </Link>
      {/* <Link to="/blogs" className="px-2.5 font-semibold text-black whitespace-nowrap">
        Events News
      </Link> */}
    </>
  );
  return (
    <div className="bg-white">
      <div className="mx-auto flex w-full max-w-[1920px] items-center justify-between gap-4 px-4 py-3 sm:px-6 sm:gap-6 lg:px-8 xl:px-10 min-[1920px]:gap-10 min-[1920px]:px-14 drop-shadow-[0_4px_4px_#00000040]">
        <Link to="/" className="shrink-0 pl-0 sm:pl-2 xl:pl-6 min-[1920px]:pl-11">
          <img
            src={Logo}
            alt="website nav bar logo"
            className="w-9 sm:w-12 xl:w-auto"
          />
        </Link>

        <div className="hidden min-w-0 flex-1 items-center justify-center gap-4 text-sm xl:flex xl:gap-16 xl:text-base max-w-[1200px]">
          {navLinks}
        </div>

        {/* Mobile menu button */}
        <button
          className="ml-auto shrink-0 pr-0 sm:pr-2 xl:hidden"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle menu"
        >
          {mobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="flex flex-col gap-4 border-t bg-white px-4 pb-4 pt-4 sm:px-6 xl:hidden">
          {navLinks}
        </div>
      )}
    </div>
  );
};
